import { createAction, createReducer, createSelector } from '@reduxjs/toolkit'
import formatDisplayPrice from '../utilities/formatDisplayPrice'
import currencySymbols from '../configuration/curencySymbols'

const handleFetchCurrencies = createAction('currencies/fetch')
export const handleReceiveCurrencies = createAction('currencies/receive')
export const handleErrorCurrencies = createAction('currencies/error')
export const updateActiveCurrency = createAction('currency/updateActive')
const initialState = {
  loading: false,
  data: null,
  error: null,
  activeCurrency: 'AUD',
}

export const currenciesReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(handleFetchCurrencies, (state) => {
      state.loading = true
    })
    .addCase(handleReceiveCurrencies, (state, action) => {
      state.loading = false
      state.data = action.payload
    })
    .addCase(handleErrorCurrencies, (state, action) => {
      state.loading = false
      state.error = action.payload
    })
    .addCase(updateActiveCurrency, (state, action) => {
      state.activeCurrency = action.payload
    })
})

export const selectCurrencyState = (state) => state.currencies

export const selectCurrencies = createSelector(selectCurrencyState, (state) => {
  return state.data || {}
})

export const selectActiveCurrency = createSelector(
  selectCurrencyState,
  (state) => state.activeCurrency
)

export const useConvertPrice = createSelector(
  selectCurrencies,
  selectActiveCurrency,
  (currencies, activeCurrency) => {
    const rate = currencies?.[activeCurrency]
    return function (price, options = {}) {
      const { displayAsInt } = options

      if (!rate) {
        const formatted = formatDisplayPrice(price, displayAsInt)
        return {
          currency: 'AUD',
          price,
          formatted,
          symbol: currencySymbols.AUD || '',
          compiled: `$${formatted}`,
        }
      }
      const symbol = currencySymbols[activeCurrency] || ''
      const formatted = formatDisplayPrice(price * rate, displayAsInt)

      return {
        currency: activeCurrency,
        price: price * rate,
        formatted,
        symbol,
        compiled: `${symbol}${formatted}`,
      }
    }
  }
)
